/*------------------------------------*\
   #SALE BANNER SESSION
\*------------------------------------*/

/*
 * Sets and checks session storage based on user interaction with the sale banner
 */

class SaleBanner {

  constructor() {
    this.init();
  }

  init() {

    const thisEl = this;
    this.checkBannerState();

    const saleBannerClose = document.querySelector('.slither-banner__close');
    if (saleBannerClose) {
      saleBannerClose.addEventListener('click', function () {
        sessionStorage['slitherBannerHidden'] = true;
        thisEl.checkBannerState();
      });
    }
  }

  checkBannerState() {
    let slitherBannerHidden = sessionStorage['slitherBannerHidden'];
    let slitherBanner = document.querySelector('.slither-banner');

    if (slitherBannerHidden === "true" && slitherBanner) {
      slitherBanner.style.display = "none";
    } else {
      slitherBanner.style.display = "block";
    }

    document.querySelector('.header-wrapper').dispatchEvent(new Event("recalculate-height"));
  }

}

const banner = new SaleBanner();